/* /assets/os-fit-dropdown.js
 * Step 4 -- progressive enhancement only for sections/os-collection-header.liquid's
 * mobile Fit <details>/<summary> dropdown. The panel opens/closes via the
 * browser's own native <details> behaviour with no JS required at all;
 * this only adds a convenience close when a shopper taps the backdrop
 * (data-fit-backdrop) behind the open panel, which native <details> has no
 * way to do on its own. If this script never runs (JS off, error), the
 * dropdown still opens and closes exactly as normal by tapping the summary
 * again -- nothing here gates the dropdown's core functionality.
 */
(function () {
  'use strict';

  function init() {
    document.addEventListener('click', function (evt) {
      var backdrop = evt.target.closest('[data-fit-backdrop]');
      if (!backdrop) return;

      var details = backdrop.closest('.os-collection-header__fit');
      if (details) {
        details.removeAttribute('open');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
